import {
  directoryNameError,
  DIRECTORY_NAME_MAX_LENGTH,
  sanitizeDirectoryName,
} from "./directoryName";

export const WORKFLOW_NAME_MAX_LENGTH = DIRECTORY_NAME_MAX_LENGTH;
export const DEFAULT_WORKFLOW_NAME = "Untitled";

export function workflowNameError(name: string): string | null {
  if (name.trim().startsWith(".")) return "Name can’t start with a dot.";
  const error = directoryNameError(name);
  return error === null ? null : `Name ${error}.`;
}

export function isValidWorkflowName(name: string): boolean {
  return workflowNameError(name) === null;
}

export function sanitizeWorkflowName(
  raw: string,
  fallback: string = DEFAULT_WORKFLOW_NAME
): string {
  return sanitizeDirectoryName(raw.replace(/^[\s.]+/, ""), fallback);
}

export function uniqueWorkflowName(
  base: string,
  taken: Iterable<string>
): string {
  const lower = new Set<string>();
  for (const n of taken) lower.add(n.toLowerCase());
  if (!lower.has(base.toLowerCase())) return base;
  for (let suffix = 2; suffix <= 1000; suffix++) {
    const candidate = `${base} (${suffix})`;
    if (!lower.has(candidate.toLowerCase())) return candidate;
  }
  return `${base} (${lower.size + 1})`;
}

// Resolve a batch of existing names to valid, unique names, in order: earlier
// names win, later sanitized collisions get a suffix. Used to backfill names
// created before enforcement.
export function resolveWorkflowNames(names: string[]): string[] {
  const taken = new Set<string>();
  return names.map((name) => {
    const resolved = uniqueWorkflowName(sanitizeWorkflowName(name), taken);
    taken.add(resolved);
    return resolved;
  });
}
